import { render, staticRenderFns } from "./DlgAdvisorNew.vue?vue&type=template&id=64864250&scoped=true"
import script from "./DlgAdvisorNew.vue?vue&type=script&lang=ts"
export * from "./DlgAdvisorNew.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64864250",
  null
  
)

export default component.exports